import InfiniteScroll from 'infinite-scroll'

export default class InfiniteScrollLoad {
    constructor(el) {

        this.el = el;
        this.setVars();
        //this.bindEvents()
    }

    setVars() {
        this.container = '[data-pagination-results]'
        this.appendTo = '[data-pagination-results]'
        this.paginationPath = '/thoughts/p'
    }

    bindEvents() {

        var scroll = new InfiniteScroll(  this.container, {
            path: function() {
               return '/thoughts/p' + ( this.loadCount + 1 );
            },
            append:  this.appendTo,
            checkLastPage: true,
            prefill: false,
            responseType: 'document',
            outlayer: false,
            scrollThreshold: 400,
            elementScroll: false,
            loadOnScroll: true,
            history: 'replace',
            historyTitle: true,
            status: undefined,
            button: undefined,
            onInit: undefined,
            debug: false,
        })


        //new Waypoint({
        //,    element: this.infiniteScroll,
        //    handler: function() {
        //        console.log('triggerd');
        //    }
        //});
    }

}
